import { render, staticRenderFns } from "./Player.vue?vue&type=template&id=0cce2e31&scoped=true&"
import script from "./Player.vue?vue&type=script&lang=tsx&"
export * from "./Player.vue?vue&type=script&lang=tsx&"
import style0 from "./Player.vue?vue&type=style&index=0&id=0cce2e31&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cce2e31",
  null
  
)

export default component.exports